import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import contactUsInfo from "./ContactUsSettings";
import { PatternFormat } from 'react-number-format';
import "./style.scss";
import sendContactUs from "./sendContactUs";
import { showMessage } from "../message-box";

function GroupBy(array, key) {
    return array.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

const ContactDropDown = ({ id, label, items, selectedItem, onChange, isRequired = true, hasEmpty = true }) => {
    return (<>
        <label htmlFor={id}>{label}</label>
        <select id={id}
            className="form-select"
            onChange={onChange}
            aria-label={label}
            autoComplete="off"
            {...(items.length === 0 ? { disabled: true } : {})}
            {...(isRequired ? { required: true } : {})}>
            {hasEmpty && <option value="">Select</option>}
            {items?.map(pt => <option key={pt.id} value={pt.id}>{pt.name}</option>)}
        </select>
    </>);
};

var ProductTypesDropDown = ({ productTypes, onChange }) => {
    let grps = GroupBy(productTypes, "groupName");

    return (
        <>
            <label htmlFor="product">Product*</label>
            <select className="form-select"
                id="product"
                onChange={onChange}
                autoComplete="off"
            >
                {Object.keys(grps).map((group, index) =>
                    <optgroup key={index} label={group}>
                        {grps[group].map(pt => <option key={pt.id} value={pt.id}>{pt.name}</option>)}
                    </optgroup>)}
            </select>
        </>
    );
};


const ContactUsForm = forwardRef(({ contactType, showRequestDemo, isTrialContact = false }, ref) => {

    // Expose submitForm and loading state to parent via ref
    useImperativeHandle(ref, () => ({
        submitForm: () => {
            return handleSubmit();
        },
        isLoading: isLoading
    }));

    const originLocation = window.location.origin || '/';
    const currentLocation = window.location.href || '/';

    // const [showRequestDemo, setShowRequestDemo] = useState(false);
    const [filteredProfileOption, setFilteredProfileOption] = useState([]);
    const [requestDemo, setRequestDemo] = useState(isTrialContact);
    const [failMessage, setFailMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [contactUsModel, setContactUsModel] = useState({
        baseUrl: originLocation,
        currentPage: currentLocation,
        requestDemo: isTrialContact,
        contactSchedule: '',
        notes: '',
        product: 'FM-Pro'
    });

    useEffect(() => {
        setContactUsModel(prev => ({ ...prev, contactType: contactType }));
    }, [contactType]);

    useEffect(() => {
        setRequestDemo(isTrialContact);
        setContactUsModel(prev => ({ ...prev, requestDemo: isTrialContact }));
    }, [isTrialContact]);

    let handelProfileTypeChange = (e) => {
        let value = +e.target.value;
        let flt = contactUsInfo.profileOptions.filter(item => item.profileTypeId === value);
        setFilteredProfileOption(flt);

        handleSelectChange(e);
    };

    let handleSelectChange = (e) => {
        const target = e.target;
        const name = target.id;

        var cm = { ...contactUsModel, [name]: target.options[target.selectedIndex].text };

        setContactUsModel(cm);
    };

    let handleInputChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.id;

        var cm = { ...contactUsModel, [name]: value };
        setContactUsModel(cm);
    };

    let handlRequestDemoChange = (e) => {
        const target = e.target;
        const name = target.id;
        const value = target.checked;

        var cm = { ...contactUsModel, [name]: value };
        setRequestDemo(target.checked);
        setContactUsModel(cm);
    }
    
    var handleSubmit = async (e) => {
        // e.preventDefault();

        setFailMessage('');

        if (!contactUsModel.profileType
            || !contactUsModel.profileOption
            || !contactUsModel.organization
            || !contactUsModel.title
            || !contactUsModel.contactName
            || !contactUsModel.phone
            || !contactUsModel.eMail
            || !contactUsModel.product
            || (contactUsModel.requestDemo && !contactUsModel.contactSchedule)) {
            setFailMessage('Please fill all required fields before send.');
            return false;
        }

        setIsLoading(true);
        try {
            await sendContactUs(contactUsModel);
            showMessage('Thank you for leaving contact request. <br/> Digital Facilities sales will contact you soon.', 'Contact Us');
            return true;
        }
        catch {
            const phone = contactUsInfo.phone;
            setFailMessage(`Sorry. Unable to submit request, please try later or call ${phone}.`)
            return false;
        }
        finally {
            setIsLoading(false);
        }
    };

    return (
        <form className="dfc-contact-us-form">
            <div className="form-group row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                    <ContactDropDown id="profileType"
                        label="Profile Type*"
                        items={contactUsInfo.profileTypes}
                        hasEmpty={true}
                        onChange={handelProfileTypeChange}
                    />
                </div>
                <div className="col-12 col-md-6">
                    <ContactDropDown id="profileOption"
                        label="Profile Option*"
                        items={filteredProfileOption}
                        hasEmpty={true}
                        onChange={handleSelectChange}
                    />
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="organization">Organization*</label>
                <input type="text" className="form-control" id="organization" name="organization" autoComplete="organization" onChange={handleInputChange} required />
            </div>
            <div className="form-group row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                    <label htmlFor="title">Title*</label>
                    <input type="text" className="form-control" id="title" name="title" autoComplete="organization-title" onChange={handleInputChange} required />
                </div>
                <div className="col-12 col-md-6">
                    <label htmlFor="contactName">Contact Name*</label>
                    <input type="text" className="form-control" id="contactName" name="contactName" autoComplete="name" onChange={handleInputChange} required />
                </div>
            </div>
            <div className="form-group row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                    <label htmlFor="phone">Phone*</label>
                    <PatternFormat id="phone" name="phone" className="form-control" format="+1 ###-###-####" mask=" " autoComplete="tel" onChange={handleInputChange} required />
                </div>
                <div className="col-12 col-md-6">
                    <label htmlFor="eMail">E-Mail*</label>
                    <input type="email" className="form-control" id="eMail" name="eMail" autoComplete="email" onChange={handleInputChange} required />
                </div>
            </div>
            <div className="form-group row">
                <div className="col-12 col-md-6 mb-3 mb-md-0">
                    <ProductTypesDropDown productTypes={contactUsInfo.productTypes} onChange={handleSelectChange} />
                </div>
                {showRequestDemo && <div className="col-12 col-md-3">
                    <div className="form-check form-switch">
                        <input className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="requestDemo"
                            checked={requestDemo}
                            onChange={handlRequestDemoChange}
                        />
                        <label className="form-check-label" htmlFor="requestDemo">Request Demo</label>
                    </div>
                </div>}
            </div>
            {requestDemo && <div className="form-group">
                <ContactDropDown id="contactSchedule"
                    label="Contact Schedule*"
                    items={contactUsInfo.contactSchedule}
                    hasEmpty={true}
                    onChange={handleSelectChange}
                />
            </div>}
            <div className="form-group">
                <label htmlFor="notes">Notes</label>
                <textarea className="form-control" id="notes" rows="2" name="notes" onChange={handleInputChange}></textarea>
            </div>
            <div className="row">
                <div className="col">
                    {failMessage && <span className="text-danger">{failMessage}</span>}
                </div>
                {/* <div className="col-auto">
                    <button className="btn btn-corporate  mb-2 float-right"
                        type="submit"
                        disabled={isLoading}
                        onClick={handleSubmit}>
                        {isLoading && <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true" />}
                        Send
                    </button>
                </div> */}
            </div>
        </form>
    );
});

export default ContactUsForm;